export function mapData(attributes, inputData) {
  const data = {};
  attributes.forEach(attribute => {
    data[attribute] = inputData?.[attribute] ?? "";
  });
  return data;
}

export const categoryAttributes = ["calculationMethods", "carbonEmission", "dataCollectionMethods", "howVerifyData",
  "materialityThreshold", "reasonExclusion"];